import React from 'react'
import Container from '@material-ui/core/Container'
import styleClasses from '../components/common/common.module.scss'
import ReservationList from '../components/reservations/ReservationList'

export default function ReservationsPage() {
  return (
    <main className={styleClasses.content}>
      <Container maxWidth="lg" className={styleClasses.container}>
        <ReservationList />
      </Container>
    </main>
  )
}
